import { render, staticRenderFns } from "./RequestHelpDialog.vue?vue&type=template&id=2538fda4&scoped=true"
import script from "./RequestHelpDialog.vue?vue&type=script&lang=js"
export * from "./RequestHelpDialog.vue?vue&type=script&lang=js"
import style0 from "./RequestHelpDialog.vue?vue&type=style&index=0&id=2538fda4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2538fda4",
  null
  
)

export default component.exports